<div class="range-wrapper">
    <ul class="ranges">
        @if (listType === 'custom') {
            <li style="height: 31px">
                <button mat-button color="primary"
                        class="active">
                    Custom
                </button>
            </li>
        }
        @for (item of rangeService.getRange(); track item.key) {
            <li style="height: 31px">
                <button mat-button color="primary"
                        [ngClass]="{'active': item.key === listType}"
                        (click)="selectRange(item)">
                    {{(item.description | mxTranslate)()}}
                </button>
            </li>
        }
    </ul>
</div>
<div class="range-picker-header">
    <button mat-icon-button (click)="previousClicked('year')">
        <mat-icon>keyboard_double_arrow_left</mat-icon>
    </button>
    <button mat-icon-button (click)="previousClicked('month')">
        <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <span class="range-picker--header-label">{{periodLabel}}</span>
    <button mat-icon-button (click)="nextClicked('month')">
        <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
    <button mat-icon-button (click)="nextClicked('year')">
        <mat-icon>keyboard_double_arrow_right</mat-icon>
    </button>
</div>
